import api from './api';

// Get all gallery items
export const getGalleryItems = (params = {}) => {
  return api.get('/gallery', { params });
};

// Get gallery item by ID
export const getGalleryItemById = (id) => {
  return api.get(`/gallery/${id}`);
};

// Create new gallery item
export const createGalleryItem = (data) => {
  return api.post('/gallery', data);
};

// Update gallery item
export const updateGalleryItem = (id, data) => {
  return api.put(`/gallery/${id}`, data);
};

// Delete gallery item
export const deleteGalleryItem = (id) => {
  return api.delete(`/gallery/${id}`);
};

// Get gallery items by category
export const getGalleryItemsByCategory = (category, params = {}) => {
  return api.get(`/gallery/category/${category}`, { params });
};

// Upload gallery photos
export const uploadGalleryPhotos = (data) => {
  return api.post('/gallery/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Get gallery statistics
export const getGalleryStats = () => {
  return api.get('/gallery/stats');
};